import focusLock from 'dom-focus-lock';
import { AccessibilityElement } from './AccessibilityElement';
import './AccessibilityStyles.scss';

class AccessibilityPlugin extends Phaser.Plugins.BasePlugin {
  constructor(pluginManager) {
    super(pluginManager);
  }

  init() {
    // create parent dom to comtain accessible nodes
    this._accessibilityWrap = document.createElement('div');
    this._accessibilityWrap.setAttribute('id', 'jgg-accessibility');

    // listen for focus and click events
    this._bindedFocus = this._handeElementFocus.bind(this);
    this._bindedBlur = this._handleElementBlur.bind(this);
    this._bindedSelect = this._handleElementSelect.bind(this);
    // enable by default
    this.enable();

    this._focusLocked = false;
    this._debug = false;
  }

  set debug(value) {
    this._debug = value;
    if (value) {
      this._accessibilityWrap.classList.add('debug');
    } else {
      this._accessibilityWrap.classList.remove('debug');
    }
  }

  // =============================================================================================
  // ENABLE / DISABLE
  // =============================================================================================

  enable() {
    // listen for focus/click events
    this._accessibilityWrap.addEventListener('focusin', this._bindedFocus);
    this._accessibilityWrap.addEventListener('focusout', this._bindedBlur);
    this._accessibilityWrap.addEventListener('click', this._bindedSelect);
    this.game.scale.parent.appendChild(this._accessibilityWrap);
    // listen for game scale changes
    this.game.scale.on('resize', this._updateScale, this);
    this._updateScale();
  }

  disable() {
    // clear listeners
    this._accessibilityWrap.removeEventListener('focusin', this._bindedFocus);
    this._accessibilityWrap.removeEventListener('focusout', this._bindedBlur);
    this._accessibilityWrap.removeEventListener('click', this._bindedSelect);
    this.game.scale.off('resize', this._updateScale, this);
    // remove main wrapper from dom
    this.game.scale.parent.removeChild(this._accessibilityWrap);
  }

  // =============================================================================================
  // ADD / REMOVE ITEMS
  // =============================================================================================

  addItem(id, ariaLabel, rect) {
    // create and return the element object
    const element = new AccessibilityElement(this._accessibilityWrap, ariaLabel, rect);
    this._log('add item', { id, ariaLabel });
    return element;
  }

  removeItem(item) {
    // just trigger destroy on the item
    item.destroy();
  }

  // =============================================================================================
  // INPUT EVENTS
  // =============================================================================================

  _handeElementFocus(e) {
    // trigger focus lock
    focusLock.on(this._accessibilityWrap);
    e.target?.controller?.focus();
    e.preventDefault();
    e.stopPropagation();
  }

  _handleElementBlur(e) {
    e.target?.controller?.blur();
    e.preventDefault();
    e.stopPropagation();
  }

  _handleElementSelect(e) {
    e.target?.controller?.select();
    e.preventDefault();
    e.stopPropagation();
  }

  // =============================================================================================
  // SCALE
  // =============================================================================================

  _updateScale() {
    const scale = this.game.scale.displaySize.height / this.game.scale.canvas.height;
    this._accessibilityWrap.style.transform = 'scale(' + scale + ')';
    this._accessibilityWrap.style.top = this.game.scale.canvas.offsetTop + 'px';
    this._accessibilityWrap.style.left = this.game.scale.canvas.offsetLeft + 'px';
  }

  // =============================================================================================
  // LOGS
  // =============================================================================================

  _log(...args) {
    this._debug && console.log('%c[AccessibilityPlugin]', 'color:#00ff00', ...args);
  }

  _warn(...args) {
    this._debug && console.warn('%c[AccessibilityPlugin]', 'color:#00ff00', ...args);
  }

  // =============================================================================================
  // SHITDOWN
  // =============================================================================================

  destroy() {
    this.disable();
    super.destroy();
  }
}

export { AccessibilityPlugin };
